import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {

  transform(value: Array<object>, args?: any): Array<Object> {
    value.sort((a: any, b: any) => {
      if (a.Key < b.Key) {
        return -1;
      } else if (a.Key > b.Key) {
        return 1;
      } else {
        return 0;
      }
    });

    return value;
  }

}
